import { render, staticRenderFns } from "./DocumentsByDIfficulty.vue?vue&type=template&id=20e61307&scoped=true"
import script from "./DocumentsByDIfficulty.vue?vue&type=script&lang=js"
export * from "./DocumentsByDIfficulty.vue?vue&type=script&lang=js"
import style0 from "./DocumentsByDIfficulty.vue?vue&type=style&index=0&id=20e61307&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e61307",
  null
  
)

export default component.exports